document.addEventListener("DOMContentLoaded", function () {
  const mobileNavTrigger = document.querySelector(".mobile-nav-trigger");
  const mobileMenu = document.querySelector(".mobile-menu");
  const mobileMenuClose = document.querySelector(".mobile-menu__close");
  const expandButtons = document.querySelectorAll(".has-subparent button");

  function toggleMobileMenu() {
    const isActive = mobileNavTrigger.classList.contains("is-active");

    mobileNavTrigger.classList.toggle("is-active");
    mobileMenu.classList.toggle("is-active");

    mobileNavTrigger.setAttribute("aria-expanded", !isActive);

    document.body.style.overflow = isActive ? "" : "hidden";
  }

  mobileNavTrigger.addEventListener("click", toggleMobileMenu);
  mobileMenuClose.addEventListener("click", toggleMobileMenu);

  expandButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const menuItem = this.closest(".mobile-menu__item");
      const isExpanded = menuItem.classList.contains("is-expanded");

      document
        .querySelectorAll(".mobile-menu__item.is-expanded")
        .forEach((item) => {
          if (item !== menuItem) {
            item.classList.remove("is-expanded");
            item
              .querySelector(".mobile-menu__expand")
              .setAttribute("aria-expanded", "false");
          }
        });

      menuItem.classList.toggle("is-expanded");
      this.setAttribute("aria-expanded", !isExpanded);
    });
  });

  window.addEventListener("resize", function () {
    if (
      window.innerWidth >= 992 &&
      mobileMenu.classList.contains("is-active")
    ) {
      toggleMobileMenu();
    }
  });

  document.addEventListener("click", function (event) {
    if (
      mobileMenu.classList.contains("is-active") &&
      !mobileMenu.contains(event.target) &&
      !mobileNavTrigger.contains(event.target)
    ) {
      toggleMobileMenu();
    }
  });

  let lastScroll = 0;
  const header = document.querySelector(".mobile-header");
  const categoryNav = document.querySelector(".category-nav");

  window.addEventListener("scroll", function () {
    const currentScroll = window.pageYOffset;

    if (currentScroll <= 0) {
      header.classList.remove("is-hidden");
      return;
    }

    if (currentScroll > lastScroll && !header.classList.contains("is-hidden")) {
      header.classList.add("is-hidden");
      if (categoryNav) categoryNav.classList.add("is-hidden");
    } else if (
      currentScroll < lastScroll &&
      header.classList.contains("is-hidden")
    ) {
      header.classList.remove("is-hidden");
      if (categoryNav) categoryNav.classList.remove("is-hidden");
    }

    lastScroll = currentScroll;
  });
});

// megamenu js

document.addEventListener("DOMContentLoaded", () => {
  const defaultIndex = "1";

  const childLinks = document.querySelectorAll(".category-nav__collection");

  childLinks.forEach((item) => {
    item.addEventListener("mouseenter", () => {
      const index = item.getAttribute("data-index");

      // Handle third-level-menu
      document.querySelectorAll(".third-level-menu").forEach((menu) => {
        menu.classList.remove("active");
      });

      // Handle active state of collection links
      document.querySelectorAll(".category-nav__collection").forEach((link) => {
        link.classList.remove("active");
      });

      // Activate the right ones
      document.querySelectorAll(`.third-level-menu[data-index="${index}"]`).forEach((menu) => {
        menu.classList.add("active");
      });

      document.querySelectorAll(`.category-nav__collection[data-index="${index}"]`).forEach((link) => {
        link.classList.add("active");
      });

      // Handle feature image block
      document.querySelectorAll(".feature-image div").forEach((img) => {
        img.classList.remove("active");
      });

      document.querySelectorAll(`.feature-image div[data-index="${index}"]`).forEach((img) => {
        img.classList.add("active");
      });
    });
  });

  document.querySelectorAll(".category-nav__submenu").forEach((submenu) => {
    submenu.addEventListener("mouseleave", () => {
      // Reset all third-level-menus
      document.querySelectorAll(".third-level-menu").forEach((menu) => {
        menu.classList.remove("active");
      });

      // Reset collections
      document.querySelectorAll(".category-nav__collection").forEach((link) => {
        link.classList.remove("active");
      });

      // Reset feature images
      document.querySelectorAll(".feature-image div").forEach((img) => {
        img.classList.remove("active");
      });

      // Re-activate defaults
      document.querySelectorAll(`.third-level-menu[data-index="${defaultIndex}"]`).forEach((menu) => {
        menu.classList.add("active");
      });

      document.querySelectorAll(`.category-nav__collection[data-index="${defaultIndex}"]`).forEach((link) => {
        link.classList.add("active");
      });

      document.querySelectorAll(`.feature-image div[data-index="${defaultIndex}"]`).forEach((img) => {
        img.classList.add("active");
      });
    });
  });
});


const mobileMenuItems = document.querySelectorAll('.mobile-menu__item.has-submenu, .mobile-menu__subitem.has-submenu , .mobile-menu__subitem-second.has-submenu');

// function handleMenuItemClick(e) {
//   if (window.innerWidth < 768) {
//     e.preventDefault();
//     e.stopPropagation();
//     this.classList.add('active');
//     const hasSubmenu = this.classList.contains('has-submenu');
//     if (!hasSubmenu && this.getAttribute('href')) {
//       window.location.href = this.getAttribute('href');
//     }
//   }
// }

// function initializeMenuListeners() {
//   if (window.innerWidth < 768) {
//     mobileMenuItems.forEach(item => {
//       item.addEventListener('click', handleMenuItemClick);
//     });
//   } else {
//     mobileMenuItems.forEach(item => {
//       item.removeEventListener('click', handleMenuItemClick);
//     });
//   }
// }

// // Initialize listeners on page load
// initializeMenuListeners();

// // Update listeners when window is resized
// window.addEventListener('resize', initializeMenuListeners);

// // Close submenus when clicking outside
// document.addEventListener('click', function(e) {
//   if (window.innerWidth < 768) {
//     const clickedInsideMenu = e.target.closest('.mobile-menu__item.has-submenu, .mobile-menu__subitem.has-submenu');
//     if (!clickedInsideMenu) {
//       mobileMenuItems.forEach(item => {
//         item.classList.remove('active');
//       });
//     }
//   }
// });

// // Add click handler for all menu items (with or without submenu)
// const allMenuItems = document.querySelectorAll('.mobile-menu__item, .mobile-menu__subitem');
// allMenuItems.forEach(item => {
//   item.addEventListener('click', function(e) {
//     if (window.innerWidth < 768) {
//       // If the item has a submenu, the existing handler will take care of it
//       // If it doesn't have a submenu, redirect to its href
//       if (!this.classList.contains('has-submenu') && this.getAttribute('href')) {
//         window.location.href = this.getAttribute('href');
//       }
//     }
//   });
// });

// if (window.innerWidth < 768) {
//   const clickableElements = document.querySelectorAll(
//     '.mobile-menu__item.has-submenu .click, ' +
//     '.mobile-menu__subitem.has-submenu .click, ' +
//     '.mobile-menu__subitem-second .mobile-menu__sublink .click'
//   );
//   clickableElements.forEach(function(el) {
//     el.addEventListener('click', function() {
//       let parent = el.closest('.has-submenu');
//       if (parent) {
//         parent.classList.add('active');
//       }
//     });
//   });
//   const closeButton = document.querySelector('.mobile-menu__close');
//   if (closeButton) {
//     closeButton.addEventListener('click', function() {
//       document.querySelectorAll('.mobile-menu__item.has-submenu.active, .mobile-menu__item.has-submenu *')
//         .forEach(function(el) {
//           el.classList.remove('active');
//         });
//     });
//   }
// }

if (window.innerWidth < 992) {
  // Handle submenu opening
  const clickableElements = document.querySelectorAll(
    ".mobile-menu__item.has-submenu button, " +
      ".mobile-menu__subitem.has-submenu button, " +
      ".mobile-menu__subitem-second.has-submenu button"
  );
  // const clickableElements = document.querySelectorAll(
  //   ".mobile-menu__item.has-submenu button"
  // );

  clickableElements.forEach(function (el) {
    el.addEventListener("click", function (e) {
      // e.preventDefault();
      let parent = el.closest(".has-submenu");
      if (parent) {
        parent.classList.add("active");
      }
    });
  });

  // Add back buttons to each submenu level
  const firstLevelMenus = document.querySelectorAll(
    ".mobile-menu__submenu--first-level"
  );
  firstLevelMenus.forEach(function (menu) {
    const backButton = document.createElement("li");
    backButton.className = "mobile-menu__back";
    backButton.innerHTML =
      '<a href="#" class="mobile-menu__back-link"><svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" class="arrow-icon"><path d="M5.31641 12.8764C5.31641 13.1389 5.53203 13.3546 5.79453 13.3546H18.207C18.4695 13.3546 18.6852 13.1389 18.6852 12.8764C18.6852 12.6139 18.4695 12.3983 18.207 12.3983H5.79453C5.53203 12.3983 5.31641 12.6139 5.31641 12.8764Z" fill="currentColor" stroke="currentColor" stroke-width="2"></path><path d="M12.9883 7.6593C12.8008 7.8468 12.8008 8.15149 12.9883 8.33899L17.868 13.2187C18.0555 13.4062 18.3602 13.4062 18.5477 13.2187C18.7352 13.0312 18.7352 12.7265 18.5477 12.539L13.668 7.6593C13.4805 7.4718 13.1758 7.4718 12.9883 7.6593Z" fill="currentColor" stroke="currentColor" stroke-width="2"></path><path d="M17.868 12.5343L12.9883 17.414C12.8008 17.6015 12.8008 17.9062 12.9883 18.0937C13.1758 18.2812 13.4805 18.2812 13.668 18.0937L18.5477 13.214C18.7352 13.0265 18.7352 12.7218 18.5477 12.5343C18.3602 12.3468 18.0555 12.3468 17.868 12.5343Z" fill="currentColor" stroke="currentColor" stroke-width="2"></path></svg> Back</a>';
    menu.insertBefore(backButton, menu.firstChild);
  });

  const secondLevelMenus = document.querySelectorAll(
    ".mobile-menu__submenu--second-level"
  );
  secondLevelMenus.forEach(function (menu) {
    const backButton = document.createElement("li");
    backButton.className = "mobile-menu__back";
    backButton.innerHTML =
      '<a href="#" class="mobile-menu__back-link"><svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" class="arrow-icon"><path d="M5.31641 12.8764C5.31641 13.1389 5.53203 13.3546 5.79453 13.3546H18.207C18.4695 13.3546 18.6852 13.1389 18.6852 12.8764C18.6852 12.6139 18.4695 12.3983 18.207 12.3983H5.79453C5.53203 12.3983 5.31641 12.6139 5.31641 12.8764Z" fill="currentColor" stroke="currentColor" stroke-width="2"></path><path d="M12.9883 7.6593C12.8008 7.8468 12.8008 8.15149 12.9883 8.33899L17.868 13.2187C18.0555 13.4062 18.3602 13.4062 18.5477 13.2187C18.7352 13.0312 18.7352 12.7265 18.5477 12.539L13.668 7.6593C13.4805 7.4718 13.1758 7.4718 12.9883 7.6593Z" fill="currentColor" stroke="currentColor" stroke-width="2"></path><path d="M17.868 12.5343L12.9883 17.414C12.8008 17.6015 12.8008 17.9062 12.9883 18.0937C13.1758 18.2812 13.4805 18.2812 13.668 18.0937L18.5477 13.214C18.7352 13.0265 18.7352 12.7218 18.5477 12.5343C18.3602 12.3468 18.0555 12.3468 17.868 12.5343Z" fill="currentColor" stroke="currentColor" stroke-width="2"></path></svg> Back</a>';
    menu.insertBefore(backButton, menu.firstChild);
  });
  const thirdLevelMenus = document.querySelectorAll(
    ".mobile-menu__submenu--third-level"
  );
  thirdLevelMenus.forEach(function (menu) {
    const backButton = document.createElement("li");
    backButton.className = "mobile-menu__back";
    backButton.innerHTML =
      '<a href="#" class="mobile-menu__back-link"><svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" class="arrow-icon"><path d="M5.31641 12.8764C5.31641 13.1389 5.53203 13.3546 5.79453 13.3546H18.207C18.4695 13.3546 18.6852 13.1389 18.6852 12.8764C18.6852 12.6139 18.4695 12.3983 18.207 12.3983H5.79453C5.53203 12.3983 5.31641 12.6139 5.31641 12.8764Z" fill="currentColor" stroke="currentColor" stroke-width="2"></path><path d="M12.9883 7.6593C12.8008 7.8468 12.8008 8.15149 12.9883 8.33899L17.868 13.2187C18.0555 13.4062 18.3602 13.4062 18.5477 13.2187C18.7352 13.0312 18.7352 12.7265 18.5477 12.539L13.668 7.6593C13.4805 7.4718 13.1758 7.4718 12.9883 7.6593Z" fill="currentColor" stroke="currentColor" stroke-width="2"></path><path d="M17.868 12.5343L12.9883 17.414C12.8008 17.6015 12.8008 17.9062 12.9883 18.0937C13.1758 18.2812 13.4805 18.2812 13.668 18.0937L18.5477 13.214C18.7352 13.0265 18.7352 12.7218 18.5477 12.5343C18.3602 12.3468 18.0555 12.3468 17.868 12.5343Z" fill="currentColor" stroke="currentColor" stroke-width="2"></path></svg> Back</a>';
    menu.insertBefore(backButton, menu.firstChild);
  });
  document.addEventListener("click", function (e) {
    if (e.target.closest(".mobile-menu__back-link")) {
      e.preventDefault();
      const submenu = e.target.closest(".mobile-menu__submenu");
      if (submenu) {
        const parentItem = submenu.closest(".has-submenu");
        if (parentItem) {
          parentItem.classList.remove("active");
        }
      }
    }
  });
  const closeButton = document.querySelector(".mobile-menu__close");
  if (closeButton) {
    closeButton.addEventListener("click", function () {
      document
        .querySelectorAll(
          ".mobile-menu__item.has-submenu.active, .mobile-menu__subitem.has-submenu.active, .mobile-menu__subitem-second.has-submenu.active"
        )
        .forEach(function (el) {
          el.classList.remove("active");
        });
    });
  }
}
if (window.innerWidth < 1200) {
  const categoryLinks = document.querySelectorAll(".category-nav__link");

  let tapped = false;
  categoryLinks.forEach((link) => {

    link.addEventListener("touchstart", function (e) {
      if (!tapped) {
        e.preventDefault();
        categoryLinks.forEach((l) => l.classList.remove("hovered"));
        this.classList.add("hovered");
        tapped = true;

      } else {
        window.location.href = this.href;
      }
    });
  });
  const categoryNav = document.querySelector(".category-nav");
  document.addEventListener("touchstart", function (e) {
    if (!categoryNav.contains(e.target)) {
      categoryLinks.forEach((link) => link.classList.remove("hovered"));
       tapped = false;
    }
  });

  const sublink = document.querySelectorAll(".sub-level");

  let tapp = false;
  sublink.forEach((link) => {

    link.addEventListener("touchstart", function (e) {
      if (!tapp) {
        e.preventDefault();
        sublink.forEach((l) => l.classList.remove("hovered"));
        this.classList.add("hovered");
        tapp = true;

      } else {
        window.location.href = this.href;
      }
    });
  });
  const subnav = document.querySelector(".top-bar");
  document.addEventListener("touchstart", function (e) {
    if (!subnav.contains(e.target)) {
      sublink.forEach((link) => link.classList.remove("hovered"));
       tapp = false;
    }
  });
}


document.querySelector('.mobile-search').addEventListener('click', function () {
  document.body.classList.toggle('open-mob-search');
});



